<template>
  <div id="loading" class="loading">
    <div>
      <img :src="logo" alt="">
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/common/loading.gif'
export default {
  name: 'Loading',
  data () {
    return {
      logo
    }
  }
}
</script>

<style scoped>
#loading {
  z-index: 15;
}

.loading {
  z-index: 15;
}
</style>



// WEBPACK FOOTER //
// src/components/Loading/index.vue